var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCardSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.17 8.748H3.2c-.66 0-1.2-.54-1.2-1.2v-.01c0-2.29 1.85-4.14 4.14-4.14h11.71c.5 0 .98.09 1.42.25l-5.1 5.1zM7.17 15.75H6c-.41 0-.75.34-.75.75 0 .31.2.59.48.69l-2.35 2.35A4.087 4.087 0 0 1 2 16.46v-5.01c0-.66.54-1.2 1.2-1.2h9.47l-5.5 5.5zM21.999 16.46c0 2.29-1.85 4.14-4.14 4.14h-9.05c-.89 0-1.34-1.08-.71-1.71l1.35-1.35a.99.99 0 0 1 .71-.29h4.34c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.84c-.89 0-1.34-1.08-.71-1.71l3.46-3.46c.38-.37.89-.58 1.42-.58h3.17c.55 0 1 .45 1 1v5.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.679 2.229-18.45 18.46c-.3.3-.3.79 0 1.09a.758.758 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.609 4.469-4.28 4.28-13.02 13.02c-.15.15-.34.23-.54.23s-.39-.08-.54-.23a.743.743 0 0 1 0-1.08l1.15-1.15 2.35-2.35 13.54-13.54 1.42-1.42c.3-.31.78-.31 1.08 0 .31.3.31.78 0 1.08l-1.16 1.16zM20.29 6.7 20 7l-.29.29c-.63.63-.19 1.71.7 1.71H21c.55 0 1-.45 1-1v-.59c0-.89-1.08-1.34-1.71-.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCardSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-card-slash.1e92866ab3794847ac35c85cd954c5bf.svg";
export { ForwardRef as ReactComponent };